const deleteActionsStore = {
  toastrSuccess: 'Acción eliminada',
  toastrSuccess1: 'eliminado con éxito'
};

export default deleteActionsStore;
